/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * Platform API
 * The Platform API
 * OpenAPI spec version: 2.0
 */

export type UtxFundApiFundTransferType = typeof UtxFundApiFundTransferType[keyof typeof UtxFundApiFundTransferType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UtxFundApiFundTransferType = {
  FUND_SUBSCRIPTION: 'FUND_SUBSCRIPTION',
  FUND_REDEMPTION: 'FUND_REDEMPTION',
  SECURITIES_TRANSFER: 'SECURITIES_TRANSFER',
} as const;
